import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import { $api, type components } from "../../helper";
import { GetFullMediaPath } from "../../helper/method";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function SocialNetworkSetting() {
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const notify = useNotify();
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/social-media/",
  );
  const deleteSocial = $api.useMutation("delete", "/site-api/v1/social-media/");
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("تنظیمات شبکه های اجتماعی");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteSocialMediaItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "تصویر شبکه اجتماعی",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <div className="aspect-square w-10 rounded-lg overflow-hidden">
          <img
            src={GetFullMediaPath(record.image)}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      ),
    },
    {
      title: "نام شبکه اجتماعی",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "لینک شبکه اجتماعی",
      dataIndex: "link",
      key: "link",
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: "/add-social-media",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/add-social-media",
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId(record.u_id);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId(record.u_id);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={deleteSocial.isPending}
        title="حذف از دسته بندی ها ؟"
        description="حذف این دسته‌بندی باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          deleteSocial.mutate(
            {
              params: {
                query: {
                  social_media_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                refetch();
                setId("");
                setIsOpen(false);
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
      <div className="w-full flex justify-end sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link to={"/add-social-media"} className="button-style">
          افزودن شبکه اجتماعی
        </Link>
      </div>

      <div>
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SiteSocialMediaItem"]>
              loading={isLoading}
              className="col-span-1!"
              scroll={{ x: "max-content" }}
              columns={columns}
              dataSource={data?.data}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
